import { render } from "./POSTGRESQL.vue?vue&type=template&id=ace30892"
import script from "./POSTGRESQL.vue?vue&type=script&lang=js"
export * from "./POSTGRESQL.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/data-adapter/POSTGRESQL.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ace30892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ace30892', __exports__)) {
    api.reload('ace30892', __exports__)
  }
  
  module.hot.accept("./POSTGRESQL.vue?vue&type=template&id=ace30892", () => {
    api.rerender('ace30892', render)
  })

}


export default __exports__